import React from 'react';
import { fullCountryNameLookup } from 'constants/i18n';
const Recipient = ({ recipient, printCompany, printName, }) => {
    if (recipient) {
        return React.createElement("span", null, recipient);
    }
    return (React.createElement(React.Fragment, null,
        printCompany && React.createElement("span", null, printCompany),
        printName && React.createElement("span", null, printName)));
};
const AccountAddress = ({ attentionLine, city, country, postalcode, printCompany, printName, recipient, state, streetAddress, streetAddressUnit, }) => {
    const streetAddressLineText = streetAddressUnit ? `${streetAddress}, ${streetAddressUnit}` : streetAddress;
    return (React.createElement("div", { className: "flex flex-col gap-1 text-sm text-black" },
        attentionLine && React.createElement("span", null, attentionLine),
        React.createElement(Recipient, { printCompany: printCompany, printName: printName, recipient: recipient }),
        React.createElement("span", null, streetAddressLineText),
        React.createElement("span", null, `${city}, ${state} ${postalcode}`),
        React.createElement("span", null, fullCountryNameLookup[country])));
};
export default AccountAddress;
